import { render } from "./Servicos.vue?vue&type=template&id=7675286c&scoped=true"
import script from "./Servicos.vue?vue&type=script&lang=js"
export * from "./Servicos.vue?vue&type=script&lang=js"

import "./Servicos.vue?vue&type=style&index=0&id=7675286c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7675286c"]])

export default __exports__